import { Countdown } from 'components/countdown';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { format, isWithinInterval, isPast, parseISO, isFuture } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import {
  getTaskCycles,
  getPlayerInfo,
  getTasks,
  getTasksManager,
  getVacationManager,
  getServerTime,
  getTasksPendingApprovalParticipants,
  getTasksManagerEcoa,
} from 'services/dashboard.service';
import { GetTaskLevelLabel, GetTaskStatusLabel } from 'utils/strings';

import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import { User, VacationManagerInterface } from 'types/user';
import VacationManagerModal from 'components/vacation-manager-modal';
import { useModal } from 'context/ModalContext';
import { getStorageItem, removeStorageItem, setStorageItem } from 'utils/storage';
import { AiOutlineWarning } from 'react-icons/ai';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { findLateralMenagers } from 'services/profile.service';
import SearchGestor from 'pages/MinhaEquipe/components/SearchGestor';
import { UserNeedingApprovalModal } from 'components/user-needing-approval-modal';
import { TasksPendingApprovalParticipantsModal } from 'components/tasks-pending-approval-participants-modal';
import { LuBell } from 'react-icons/lu';
import ProgressBar from 'components/ui/progress-bar';
import { MdOutlineLock } from 'react-icons/md';

export function TaskCyclesEcoa() {
  const navigate = useNavigate();
  const { user, userInfo, cycles, currentCycle, realCycle } = useAuth();
  const { showModal, closeModal } = useModal();
  const [canRegister, setCanRegister] = useState(true);

  // const [tasks, setTasks] = useState<any>();
  const [currentTaskCycle, setCurrentTaskCycle] = useState<any>();
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [taskCycles, setTaskCycles] = useState<any>();
  const [myTasks, setMyTasks] = useState<any[]>();
  const [otherTasks, setOtherTasks] = useState<any[]>();

  const [evaluateTasks, setEvaluateTasks] = useState<any[]>();
  const [playerInfo, setPlayerInfo] = useState<any>();
  const [cycleActive, setCycleActive] = useState<string>();
  const [evaluateCycleActive, setEvaluateCycleActive] = useState<string>();
  const [evaluateActiveCycle, setEvaluateActiveCycle] = useState<string | null>();
  const [lateralManagers, setLateralManagers] = useState<User[]>();
  const [showModalLateral, setShowModalLateral] = useState(false);
  const [isExperied, setIsExperied] = useState(false);
  const [isStarting, setIsStarting] = useState(false);

  const [realDatetime, setRealDatetime] = useState<number>(0);
  const [hasTime, setHasTime] = useState(false);

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);

      setHasTime(true);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const activeCycleObj = useMemo(() => taskCycles?.find((item: any) => item._id === cycleActive), [cycleActive, taskCycles]);

  const evaluateActiveNow = useMemo(
    () => taskCycles?.find((item: any) => item._id === evaluateActiveCycle),
    [evaluateActiveCycle, taskCycles],
  );

  const evaluateActiveCycleObj = useMemo(
    () => taskCycles?.find((item: any) => item._id === evaluateCycleActive),
    [evaluateCycleActive, taskCycles],
  );

  const activeCycleSelectObj = useMemo(
    () => realCycle?.find((item: any) => item._id === evaluateActiveCycleObj?.cycleId),
    [evaluateActiveCycleObj?.cycleId, realCycle],
  );

  const taskPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !taskCycles?.length || !cycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === cycleActive);
    const tasks = myTasks.filter(
      (item: any) => item.created >= cycle.date_start && item.created <= cycle.date_finish && item.status !== 'arquivado',
    );

    return tasks?.length ? tasks[0] : null;
  }, [cycleActive, myTasks, taskCycles]);

  const evaluateTaskPerCycle: any = useMemo(() => {
    if (!Array.isArray(evaluateTasks) || !taskCycles?.length || !evaluateCycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks = evaluateTasks;

    return tasks?.length ? tasks[tasks.length - 1] : null;

    // let tasksFiltered = tasks.filter((item: any) => !!isCurrentEvaluator(item));

    // if (tasksFiltered?.length) {
    //   tasksFiltered = tasksFiltered[tasksFiltered.length - 1];
    // } else {
    //   tasksFiltered = tasks[tasks.length - 1];
    // }

    // console.log(tasksFiltered);

    // return !!tasksFiltered ? tasksFiltered : null;
  }, [evaluateCycleActive, evaluateTasks, taskCycles]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!evaluateActiveCycleObj || !realDatetime) return null;

    if (
      realDatetime > evaluateActiveCycleObj.evaluation_ecoa_days_step2_start &&
      realDatetime < evaluateActiveCycleObj.evaluation_ecoa_days_step2_finish
    ) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step3_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step4_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_pitStop_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step5_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [evaluateActiveCycleObj, realDatetime]);

  const getPlayerStep = (task: any) => {
    if (playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') {
      if (
        (playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') &&
        (task.status === 'ciente' || task.status === 'aguardando')
      ) {
        return 2;
      }

      if ((playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') && task.status === 'aprovado') {
        return 5;
      }
    }

    return 0;
  };

  const htmlCountdownEvaluation = useMemo(() => {
    if (
      !evaluateActiveCycleObj ||
      (!getActiveEvaluationStep && getActiveEvaluationStep !== 0) ||
      !playerInfo ||
      !Array.isArray(evaluateTasks) ||
      !taskCycles?.length ||
      !evaluateCycleActive
    ) {
      setIsExperied(true);

      return <></>;
    }

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks: any[] = evaluateTasks;
    if (evaluateActiveCycleObj.status === 'open') {
      setIsExperied(false);
      return (
        <div>
          <span className="text-white font-thin">
            O período de avaliação desta fase inicia em:{' '}
            <strong className="font-semibold whitespace-nowrap">
              <Countdown key="missao" deadline={new Date(evaluateActiveCycleObj.date_finish)} />
            </strong>
          </span>

          {/* PROGRESS */}
          <div className="lg:w-[120%] mt-2">
            <ProgressBar startDate={evaluateActiveCycleObj?.date_start} endDate={evaluateActiveCycleObj?.date_finish} />
          </div>
        </div>
      );
    } else if (evaluateActiveCycleObj.status === 'evaluation') {
      if (tasks.length) {
        const userTaskStep: number[] = tasks
          .map(task => (typeof getPlayerStep(task) === 'number' ? (getPlayerStep(task) as number) : 0))
          .sort(() => -1);

        if (userTaskStep.includes(getActiveEvaluationStep) || (getActiveEvaluationStep === 5 && userTaskStep.includes(2))) {
          const date_start =
            getActiveEvaluationStep === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
              : evaluateActiveCycleObj?.date_evaluation_step5_start;

          const date_finish =
            getActiveEvaluationStep === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
              : evaluateActiveCycleObj?.date_evaluation_step5_finish;

          setIsExperied(false);

          return (
            <div>
              <span className="text-white font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </span>

              {/* PROGRESS */}
              <div className="lg:w-[80%] mt-2">
                <ProgressBar startDate={evaluateActiveCycleObj?.date_start} endDate={evaluateActiveCycleObj?.date_finish} />
              </div>
            </div>
          );
        } else {
          const hasAfter = userTaskStep?.find((x: number) => x > (getActiveEvaluationStep as number));

          const date_start =
            hasAfter === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
              : hasAfter === 3
                ? evaluateActiveCycleObj?.date_evaluation_step5_start
                : hasAfter === 4
                  ? evaluateActiveCycleObj?.date_evaluation_step5_start
                  : hasAfter === 4.1
                    ? evaluateActiveCycleObj?.date_evaluation_step5_start
                    : evaluateActiveCycleObj?.date_evaluation_step5_start;

          const date_finish =
            hasAfter === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
              : hasAfter === 3
                ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                : hasAfter === 4
                  ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                  : hasAfter === 4.1
                    ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                    : evaluateActiveCycleObj?.date_evaluation_step5_finish;

          if (!!hasAfter) {
            setIsExperied(false);
            setIsStarting(true);
            return (
              <div>
                <span className="text-white font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="font-semibold whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </span>

                {/* PROGRESS */}
                <div className="lg:w-[120%] mt-2">
                  <ProgressBar startDate={evaluateActiveCycleObj?.date_start} endDate={evaluateActiveCycleObj?.date_finish} />
                </div>
              </div>
            );
          } else {
            setIsExperied(true);
            return <></>;
          }
        }
      } else {
        const codEtapa =
          playerInfo.cod_etapa === 2
            ? 2
            : playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3
              ? 3
              : playerInfo.cod_etapa === 4
                ? 4
                : playerInfo.cod_etapa === 5
                  ? 5
                  : null;

        if (codEtapa) {
          if (getActiveEvaluationStep === codEtapa) {
            const date_finish =
              getActiveEvaluationStep === 2
                ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
                : getActiveEvaluationStep === 3
                  ? evaluateActiveCycleObj?.date_evaluation_step3_finish
                  : getActiveEvaluationStep === 4
                    ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                    : evaluateActiveCycleObj?.date_evaluation_step5_finish;

            setIsExperied(false);
            return (
              <span className="text-white font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </span>
            );
          } else {
            if (getActiveEvaluationStep < codEtapa) {
              const date_start =
                codEtapa === 2
                  ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
                  : codEtapa === 3
                    ? evaluateActiveCycleObj?.date_evaluation_step3_start
                    : codEtapa === 4
                      ? evaluateActiveCycleObj?.date_evaluation_step4_start
                      : evaluateActiveCycleObj?.date_evaluation_step5_start;
              setIsExperied(false);
              setIsStarting(true);
              return (
                <span className="text-white font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="font-semibold whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </span>
              );
            } else {
              setIsExperied(true);
              return <></>;
            }
          }
        } else {
          setIsExperied(true);
          return <></>;
        }
      }
    } else {
      setIsExperied(true);
      return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateActiveCycleObj, evaluateCycleActive, evaluateTasks, getActiveEvaluationStep, playerInfo, taskCycles]);

  const hasToEvaluate = useMemo(() => {
    if (!Array.isArray(evaluateTasks)) {
      return false;
    }

    const tasks = evaluateTasks.filter((item: any) => {
      if (!getActiveEvaluationStep) return false;
      const lastManager = item?.evaluator?.length ? item.evaluator[item.evaluator.length - 1] : item.original_manager;

      // if (lastManager !== playerInfo?._id) {
      //   return false;
      // }

      console.log(getActiveEvaluationStep);

      if (
        getActiveEvaluationStep >= 5 &&
        (item.status === 'concluido' || item.status === 'dobrado' || item.status === 'concluidoAuto')
      ) {
        return false;
      }

      if (getActiveEvaluationStep === 2 && item.status === 'aprovado') {
        return false;
      }

      if (getActiveEvaluationStep > 2 && item.status === 'aguardando') {
        return false;
      }

      if (
        item.status === 'ciente' ||
        item.status === 'concluido' ||
        item.status === 'concluidoAuto' ||
        item.status === 'dobrado'
      ) {
        return false;
      }

      if (
        getActiveEvaluationStep &&
        getActiveEvaluationStep > 2 &&
        lastManager === playerInfo?._id &&
        (item.status === 'concluidoAuto' || item.status === 'concluido' || item.status === 'selo')
      ) {
        return false;
      }

      return true;
    });

    console.log(tasks.length);

    return tasks.length > 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateTasks, getActiveEvaluationStep, playerInfo]);

  const showHasEvaluated = useMemo(() => {
    // !isStarting
    if (!isExperied && !hasToEvaluate) {
      return true;
    }

    if (!hasToEvaluate && getActiveEvaluationStep === 2) {
      return true;
    }

    return false;
  }, [hasToEvaluate, isExperied, getActiveEvaluationStep]);

  useEffect(() => {
    async function getUserInfo() {
      try {
        const _playerInfo: any = userInfo;

        if (_playerInfo) {
          setPlayerInfo(_playerInfo);
          setCanRegister(!!_playerInfo?.ecoa && _playerInfo?.ecoa === 'INTEGRANTE');

          const taskCycleResults = await getTaskCycles();
          setTaskCycles(taskCycleResults);

          const currentStage = taskCycleResults.find((item: any) => item.status === 'evaluation');

          setEvaluateActiveCycle(currentStage?._id ? currentStage._id : taskCycleResults[0]?._id);

          // Pode cadastrar
          if (!!_playerInfo?.ecoa && _playerInfo?.ecoa === 'INTEGRANTE') {
            const data = await getTasks(user?._id, null, null, true);

            const my_tasks = data.filter((item: any) => item.owner === user?._id);

            setMyTasks(my_tasks);

            const currentCycle = taskCycleResults.find((item: any) => item.status === 'open');

            setCycleActive(currentCycle?._id || taskCycleResults[0]._id);
          }

          // Gestor

          if (!!_playerInfo?.ecoa && (_playerInfo?.ecoa === 'TUTOR' || _playerInfo?.ecoa === 'COORDENADOR')) {
            const currentStage = taskCycleResults.find((item: any) => item.status === 'evaluation');
            const stageId = currentStage?._id || taskCycleResults[0]._id;
            const cycleObj = realCycle?.find(e => e._id === currentStage?.cycleId);
            const cycleId = currentCycle?._id || taskCycles.find((item: any) => item.type && item.type === 'month')?._id;

            const start =
              !!currentStage &&
              realDatetime >= currentStage?.date_evaluation_step5_start &&
              realDatetime <= currentStage?.date_evaluation_step5_finish &&
              !!cycleObj
                ? cycleObj.date_start
                : currentStage?._id === '67241c4a81985d067f49c740'
                  ? 1730174400000
                  : taskCycleResults.find((item: any) => item._id === cycleId)?.date_start;

            const end =
              currentStage &&
              realDatetime >= currentStage?.date_evaluation_step5_start &&
              realDatetime <= currentStage?.date_evaluation_step5_finish &&
              !!cycleObj
                ? cycleObj.date_end
                : taskCycleResults.find((item: any) => item._id === cycleId)?.date_finish;

            const data = await getTasksManagerEcoa(user?.extra.id, start, end);

            setEvaluateTasks(data);
            setEvaluateCycleActive(cycleId);
          }
        }

        setLoadingTasks(false);
      } catch (e) {
        console.log(e);
      }
    }

    if (user && !playerInfo && hasTime && realCycle) {
      getUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerInfo, user, userInfo, hasTime, realCycle]);

  function getDescription() {
    return (
      <p>
        Você possui acordo individual do tipo pré-definido na Plataforma Conexão e por isso, não realiza o cadastramento, mas pode
        participar de ações de outras equipes, participando da premiação coletiva. <br />
        <br />
        Para premiação individual a pontuação final das Ações ECOA será pelo Placar Consolidado da Plataforma Conexão.
      </p>
    );
  }

  function getAgenda() {
    if (!playerInfo || !evaluateActiveNow) return null;

    const now = new Date();
    const agendaItem = evaluateActiveNow;

    const isCienteValida =
      agendaItem?.evaluation_ecoa_days_step2_start && agendaItem?.evaluation_ecoa_days_step2_finish
        ? {
            isActive: isWithinInterval(now, {
              start: new Date(agendaItem.evaluation_ecoa_days_step2_start),
              end: new Date(agendaItem.evaluation_ecoa_days_step2_finish),
            }),
            isPast: isPast(new Date(agendaItem.evaluation_ecoa_days_step2_finish)),
            isFuture: isFuture(new Date(agendaItem.evaluation_ecoa_days_step2_start)),
          }
        : null;

    const isBonifica =
      agendaItem?.date_evaluation_step5_start && agendaItem?.date_evaluation_step5_finish
        ? {
            isActive: isWithinInterval(now, {
              start: new Date(agendaItem.date_evaluation_step5_start),
              end: new Date(agendaItem.date_evaluation_step5_finish),
            }),
            isPast: isPast(new Date(agendaItem.date_evaluation_step5_finish)),
            isFuture: isFuture(new Date(agendaItem.date_evaluation_step5_start)),
          }
        : null;

    const renderStageState = (stage: { isActive: boolean; isFuture: boolean } | null) => {
      const state = stage?.isActive ? 'em andamento' : stage?.isFuture ? 'ainda não iniciada' : '';
      return state ? <span className="sr-only">{`, ${state}`}</span> : null;
    };

    const formatDateRange = (start: number, end: number) => {
      return `De ${format(new Date(start), 'dd/MM', { locale: ptBR })} a ${format(new Date(end), 'dd/MM', { locale: ptBR })}`;
    };

    const calculateProgress = (start: number, end: number) => {
      const total = end - start;
      const elapsed = now.getTime() - start;
      const progress = Math.max(0, Math.min(100, (elapsed / total) * 100));
      return progress;
    };

    return (
      <div className="bg-maastricht-blue rounded-2xl p-4 lg:p-6 space-y-4 w-full">
        <h3 className="text-lg">Agenda de Apreciação</h3>

        <ul className="grid grid-cols-2 gap-3">
          <li className="w-full space-y-2">
            <div
              className={`flex items-center space-x-1 ${isCienteValida?.isActive || isCienteValida?.isPast ? 'text-white' : 'text-[#9DB5C9]'}`}
            >
              {isCienteValida?.isFuture && <MdOutlineLock size={18} aria-hidden="true" />}
              <span>
                Ciente/Válida
                {renderStageState(isCienteValida)}
              </span>
            </div>

            {isCienteValida?.isActive ? (
              <div className="w-full bg-white rounded-2xl h-[10px] overflow-hidden">
                <div 
                  className="h-full bg-[#FF3E5A] rounded-2xl transition-all duration-1000 ease-out"
                  style={{ 
                    width: `${calculateProgress(
                      agendaItem.evaluation_ecoa_days_step2_start, 
                      agendaItem.evaluation_ecoa_days_step2_finish
                    )}%` 
                  }}
                ></div>
              </div>
            ) : (
              <div className={`w-full rounded-2xl h-[10px] ${isCienteValida?.isPast ? 'bg-electric-blue' : 'bg-[#C7D3EB]'}`}></div>
            )}

            <p className={`${isCienteValida?.isPast ? 'text-white' : 'text-[#FF8FA0]'} font-bold text-sm`}>
              {isCienteValida?.isPast
                ? 'Finalizado'
                : agendaItem?.evaluation_ecoa_days_step2_start && agendaItem?.evaluation_ecoa_days_step2_finish
                  ? formatDateRange(agendaItem.evaluation_ecoa_days_step2_start, agendaItem.evaluation_ecoa_days_step2_finish)
                  : ''}
            </p>
          </li>

          <li className="w-full space-y-2">
            <div
              className={`flex items-center space-x-1 ${isBonifica?.isActive || isBonifica?.isPast ? 'text-white' : 'text-[#9DB5C9]'}`}
            >
              {isBonifica?.isFuture && <MdOutlineLock size={18} aria-hidden="true" />}
              <span>
                Bonifica
                {renderStageState(isBonifica)}
              </span>
            </div>

            {isBonifica?.isActive ? (
              <div className="w-full bg-white rounded-2xl h-[10px] overflow-hidden">
                <div 
                  className="h-full bg-[#FF3E5A] rounded-2xl transition-all duration-1000 ease-out"
                  style={{ 
                    width: `${calculateProgress(
                      agendaItem.date_evaluation_step5_start, 
                      agendaItem.date_evaluation_step5_finish
                    )}%` 
                  }}
                ></div>
              </div>
            ) : (
              <div className={`w-full rounded-2xl h-[10px] ${isBonifica?.isPast ? 'bg-electric-blue' : 'bg-[#C7D3EB]'}`}></div>
            )}

            <p className={`${isBonifica?.isPast ? 'text-white' : 'text-[#FF8FA0]'} font-bold text-sm`}>
              {isBonifica?.isPast
                ? 'Finalizado'
                : agendaItem?.date_evaluation_step5_start && agendaItem?.date_evaluation_step5_finish
                  ? formatDateRange(agendaItem.date_evaluation_step5_start, agendaItem.date_evaluation_step5_finish)
                  : ''}
            </p>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col">
        {!loadingTasks ? (
          <>
            <div className="space-y-6 flex flex-col w-full">
              {/* {!!taskPerCycle || !!evaluateTaskPerCycle ? (
                <>
                  <div className="text-white font-normal text-xl lg:text-2xl leading-none -mb-4 text-left">
                    Ações ECOA
                  </div>
                  <p className="text-white text-xs lg:text-sm block font-thin">
                    Visualize suas Ações ECOA e acompanhe os status de apreciação.
                  </p>
                </>
              ) : null} */}

              {/* Cadastro */}
              {!!canRegister ? (
                <div>
                  {!!taskPerCycle ? (
                    <div>
                      <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-5 text-left" tabIndex={0}>
                        Última ação ECOA cadastrada
                      </h2>

                      {/* <p className="text-base lg:text-base leading-none block mb-3 lg:mb-4 text-yellow">

                      </p> */}

                      <div className="flex items-center justify-between flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-8">
                        <div className="flex-1 bg-maastricht-blue rounded-lg p-4 lg:p-6 text-sm space-y-3">
                          <p className="font-thin">
                            <strong className="font-normal">Título da Ação:</strong> {taskPerCycle.title}
                          </p>
                          <p className="font-thin">
                            <strong className="font-normal ">Status da entrega:</strong>{' '}
                            <strong className="text-[#FF3E5A]">{GetTaskLevelLabel(taskPerCycle.status)}</strong>
                            {/* <strong className="text-white">{GetTaskLevelLabel(taskPerCycle.status)}</strong> */}
                          </p>
                        </div>

                        {/* {activeCycleObj?.status === 'open' ? (
                          <span className="text-white block lg:hidden text-xs font-thin pb-3">
                            A fase será finalizada em:{' '}
                            <strong className="font-semibold">
                              <Countdown key="missao" deadline={new Date(activeCycleObj?.date_finish)} />
                            </strong>
                          </span>
                        ) : null} */}
                      </div>

                      {activeCycleObj?.status === 'open' ? (
                        <span className="text-white hidden lg:block mt-5 text-sm font-thin">
                          A fase será finalizada em:{' '}
                          <strong className="font-semibold">
                            <Countdown key="missao" deadline={new Date(activeCycleObj?.date_finish)} />
                          </strong>
                        </span>
                      ) : null}

                      <div className="my-5 w-[60%]">
                        <ProgressBar startDate={activeCycleObj?.date_start} endDate={activeCycleObj?.date_finish} />
                      </div>

                      {/* AGENDA */}
                      <div className="mt-5">{getAgenda()}</div>

                      <div className="mt-9 flex flex-col lg:flex-row items-center justify-center space-y-3 lg:space-y-0 lg:space-x-6">
                        {!!playerInfo?.ecoa &&
                          playerInfo?.ecoa === 'INTEGRANTE' &&
                          activeCycleObj?.status === 'open' &&
                          activeCycleObj?._id !== '68af4da8458e527eaa788503' &&
                          user?.extra?.actions !== false &&
                          !playerInfo?.visualizador && (
                            <button
                              className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue hover:ring hover:ring-white rounded w-auto px-3 lg:px-4 h-10"
                              onClick={() => navigate('/acao-ecoa/cadastrar')}
                              aria-label="Cadastrar realização. Abre modal"
                            >
                              Cadastrar ação
                            </button>
                          )}

                        <button
                          className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-10`}
                          onClick={() => navigate('/acao-ecoa')}
                        >
                          Acompanhar ações
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-9">
                        <div>
                          <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left" tabIndex={0}>
                            Ações ECOA
                          </h2>

                          <p className="font-thin" tabIndex={0}>
                            Visualize suas Ações ECOA e acompanhe o status de apreciação.
                          </p>

                          {!!playerInfo?.ecoa && playerInfo?.ecoa === 'INTEGRANTE' && activeCycleObj?.status !== 'closed' && (
                            <p
                              className="block mb-4 mt-6 font-normal text-base lg:text-lg text-yellow tracking-tight"
                              tabIndex={0}
                            >
                              Que tal cadastrar Ações ECOA neste mês?
                            </p>
                          )}

                          {/* <p className="font-thin" tabIndex={0}>
                            Cadastre sua Ação ECOA, seja reconhecido pela sua liderança e ganhe recompensas! <b>Lembre-se:</b>{' '}
                            você só pode cadastrar duas ações por fase e ela deve estar concluída.
                          </p> */}

                          {activeCycleObj?.status !== 'closed' && (
                            <span className="text-white hidden lg:block mt-3 text-sm font-thin" tabIndex={0}>
                              Neste mês, o cadastramento será finalizado em:{' '}
                              <strong className="font-semibold">
                                <Countdown key="missao" deadline={new Date(activeCycleObj?.date_finish)} />
                              </strong>
                            </span>
                          )}

                          {/* PROGRESS */}
                          {activeCycleObj?.status !== 'closed' && (
                            <div className="lg:w-[120%] mt-2">
                              <ProgressBar
                                startDate={activeCycleSelectObj?.date_start}
                                endDate={activeCycleSelectObj?.date_end}
                              />
                            </div>
                          )}
                        </div>

                        {/* <div aria-hidden={true}>
                          <img src={ImgFeedback} className="max-w-[186px]" alt="" />
                        </div> */}
                      </div>

                      {activeCycleObj?.status === 'closed' && playerInfo?.ecoa === 'INTEGRANTE' && (
                        <p className="text-white text-sm block font-thin tracking-tight -mt-6">
                          <strong className="font-normal text-base lg:text-lg block mb-4 text-yellow">
                            Você não possui Ação ECOA cadastrada nesta fase.
                          </strong>
                        </p>
                      )}

                      {/* AGENDA */}
                      <div className="mt-5">{getAgenda()}</div>

                      {activeCycleObj?.status === 'open' ? (
                        <>
                          <div className="mt-5 flex flex-col lg:flex-row items-center justify-center space-y-3 lg:space-y-0 lg:space-x-6">
                            {!!playerInfo?.ecoa &&
                              playerInfo?.ecoa === 'INTEGRANTE' &&
                              user?.extra?.actions !== false &&
                              activeCycleObj?._id !== '68af4da8458e527eaa788503' &&
                              !playerInfo?.visualizador && (
                                <button
                                  className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue hover:ring hover:ring-white rounded w-auto px-3 lg:px-4 h-10"
                                  onClick={() => navigate('/acao-ecoa/cadastrar')}
                                  aria-label="Cadastrar realização. Abre modal"
                                >
                                  Cadastrar ação
                                </button>
                              )}

                            <button
                              className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-10`}
                              onClick={() => navigate('/acao-ecoa')}
                              aria-label="Acompanhar minhas Ações ECOA"
                            >
                              Acompanhar ações
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="flex justify-center mt-10">
                            <button
                              className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal hover:ring hover:ring-white lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-10`}
                              onClick={() => navigate('/acao-ecoa')}
                            >
                              Acompanhar ações
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {!!playerInfo?.ecoa && (playerInfo?.ecoa === 'TUTOR' || playerInfo?.ecoa === 'COORDENADOR') ? (
                <div>
                  {!!evaluateTaskPerCycle ? (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-5">
                        <div>
                          <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left">Ações ECOA</div>
                          {!isExperied && hasToEvaluate && !isStarting && (
                            <p className="block mb-4 mt-6 font-normal text-base lg:text-lg text-yellow tracking-tight">
                              Você tem Ações ECOA esperando serem apreciadas!
                            </p>
                          )}

                          {showHasEvaluated ? (
                            <>
                              <p className="block mb-4 mt-6 font-normal text-base lg:text-lg text-yellow tracking-tight">
                                Não há nenhuma Ação ECOA aguardando apreciação
                              </p>
                              {/* <p className="font-thin">Acesse o botão "Acompanhar ações" para visualizar.</p> */}
                            </>
                          ) : (
                            <p className="font-thin">
                              Acesse as Ações ECOA e inicie a etapa de apreciação. <b>Lembre-se:</b> você precisa apreciar as
                              Ações antes do prazo expirar.
                            </p>
                          )}

                          {/* vOLTAR */}
                          <span className="block mt-3 text-sm">{htmlCountdownEvaluation}</span>
                        </div>

                        {/* <div>
                          <img src={ImgFeedback} className="max-w-[186px]" alt=" " />
                        </div> */}
                      </div>

                      {/* AGENDA */}
                      <div className="mt-5">{getAgenda()}</div>

                      <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 items-center justify-center md:space-x-4 mt-5">
                        <button
                          className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-auto px-5 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/validar-acao-ecoa')}
                        >
                          APRECIAR ações ECOA
                        </button>

                        {/* {!!lateralManagers?.length && evaluateActiveCycleObj?.status === 'evaluation' && (
                          <button
                            className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                            onClick={() => setShowModalLateral(true)}
                          >
                            Apreciar ações <br />
                            Lateralidade/Substituição
                          </button>
                        )} */}

                        {/* <button
                          className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/acao-ecoa')}
                        >
                          Acompanhar MINHAS ações
                        </button>  */}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-5">
                        <div>
                          <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left">Ações ECOA</div>

                          <p className="block mb-4 mt-6 font-normal text-base lg:text-lg text-yellow tracking-tight">
                            Não há nenhuma Ação ECOA aguardando apreciação
                          </p>

                          <p className="font-thin">Acesse o botão "Acompanhar ações" para visualizar.</p>

                          {/* vOLTAR */}
                          {/* <span className="block mt-3 text-sm">{htmlCountdownEvaluation}</span> */}
                        </div>

                        {/* <div>
                          <img src={ImgFeedback} className="max-w-[186px]" alt=" " />
                        </div> */}
                      </div>

                      {/* AGENDA */}
                      <div className="mt-5">{getAgenda()}</div>

                      <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 items-center justify-center md:space-x-4">
                        <button
                          className={`mt-5 text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/validar-acao-ecoa')}
                        >
                          Acompanhar ações ECOA
                        </button>

                        {/* {!!lateralManagers?.length && evaluateActiveCycleObj?.status === 'evaluation' && (
                          <button
                            className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-11 leading-tight`}
                            onClick={() => setShowModalLateral(true)}
                          >
                            Apreciar ações <br />
                            Lateralidade/Substituição
                          </button>
                        )} */}

                        {/* <button
                          className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/acao-ecoa')}
                        >
                          Acompanhar MINHAS ações
                        </button> */}
                      </div>
                    </>
                  )}
                </div>
              ) : null}
              {/* {canRegister ? (
                    <></>
                  ) : (
                    <>
                      <p className="text-white text-sm block mb-6 font-thin text-center tracking-tight">
                        <strong className="font-semibold text-base lg:text-lg block mb-4 text-yellow">
                          Sua equipe ainda não cadastrou Ações ECOA nesta fase
                        </strong>
                      </p>
                    </>
                  )} */}
              {/* <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center mt-8 w-full"> */}
              {/* {taskCycles?.map((item: any) => {
            // const buttonColor =
            //   item.status === "open" ? "secondary" : "outline";
            return (
              <div className="flex items-center space-x-5" key={item._id}>
                <div className="bg-maastricht-blue rounded-md px-5 py-3 text-sm">
                  <p className="font-thin ">
                    <b className="font-normal">Nome da ação:</b> Protótipo para
                    o JogaJuntoBB
                  </p>
                  <p className="font-thin">
                    <b className="font-normal">Status da entrega:</b> Aguardando
                    validação
                  </p>
                </div>

                <Button
                  color="primary"
                  className="uppercase py-2 text-sm"
                  onClick={() => navigate("/acao")}
                >
                  {item.title} - {GetTaskStatusLabel(item.status)}
                </Button>
              </div>
            );
          })} */}
              {/* {!canRegister && (
            <Button color="outline" className="uppercase py-2 bg-yellow" onClick={() => navigate('/acao')}>
              1º Fase - Em validação
            </Button>
          )}

          {!canRegister && !tasks && (
            <Button className="uppercase py-2" onClick={() => navigate('/acao')}>
              2º Fase - cadastrar
            </Button>
          )}

          {!canRegister && !!tasks && (
            <Button
              onClick={() => navigate(`/acao`)}
              color="clear"
              className="uppercase py-2 bg-blue-light text-blue-dark"
            >
              <div className="flex flex-row items-center space-x-2">
                <span>Ver suas entregas</span>
                <BiEdit />
              </div>
            </Button>
          )} */}
              {/* {!!tasks && tasks.status === 'ok' && (
        <div className="py-2 px-3 rounded-full bg-green-700 ring-2 ring-white text-white">
          <div className="">
            <span>Entrega Reconhecida: </span> +{getTaskPoints(tasks)} pontos
          </div>
        </div>
      )} */}
              {/* {canRegister && (
            <Button
              color="clear"
              className="uppercase py-2 bg-yellow text-blue-dark"
              onClick={() => navigate("/minha-equipe/validar-apreciar-realizacao")}
            >
              Avaliar Entregas da Equipe
            </Button>
          )} */}
            </div>
          </>
        ) : (
          <div className="text-center text-lg p-2 px-4 border rounded-full mt-3">Carregando informações...</div>
        )}
      </div>

      {!!lateralManagers?.length && evaluateActiveCycleObj?.status === 'evaluation' && showModalLateral && (
        <SearchGestor
          closeModal={() => setShowModalLateral(false)}
          onSubmit={id => {
            setStorageItem('manager_lateralidade', id._id);
            setShowModalLateral(false);
            navigate('/validar-acao-ecoa');
          }}
        />
      )}
    </>
  );
}
